// source: imports/content/language_code.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) {
    return this;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  return Function('return this')();
}.call(null));

goog.exportSymbol('proto.com.chegg.rio.content.LanguageCode', null, global);
/**
 * @enum {number}
 */
proto.com.chegg.rio.content.LanguageCode = {
  UNKNOWN_LANGUAGECODE: 0,
  AF: 1,
  SQ: 2,
  AM: 3,
  AR: 4,
  HY: 5,
  AS: 6,
  AY: 7,
  AZ: 8,
  BM: 9,
  EU: 10,
  BE: 11,
  BN: 12,
  BHO: 13,
  BS: 14,
  BG: 15,
  CA: 16,
  CEB: 17,
  CO: 18,
  HR: 19,
  CS: 20,
  DA: 21,
  DV: 22,
  DOI: 23,
  NL: 24,
  EN: 25,
  EO: 26,
  ET: 27,
  EE: 28,
  FIL: 29,
  FI: 30,
  FR: 31,
  FY: 32,
  GL: 33,
  KA: 34,
  DE: 35,
  EL: 36,
  GN: 37,
  GU: 38,
  HT: 39,
  HA: 40,
  HAW: 41,
  HE: 42,
  HI: 43,
  HMN: 44,
  HU: 45,
  IS: 46,
  IG: 47,
  ILO: 48,
  ID: 49,
  GA: 50,
  IT: 51,
  JA: 52,
  JV: 53,
  KN: 54,
  KK: 55,
  KM: 56,
  RW: 57,
  GOM: 58,
  KO: 59,
  KRI: 60,
  KU: 61,
  CKB: 62,
  KY: 63,
  LO: 64,
  LA: 65,
  LV: 66,
  LN: 67,
  LT: 68,
  LG: 69,
  LB: 70,
  MK: 71,
  MAI: 72,
  MG: 73,
  MS: 74,
  ML: 75,
  MT: 76,
  MI: 77,
  MR: 78,
  LUS: 79,
  MN: 80,
  MY: 81,
  NE: 82,
  NO: 83,
  NY: 84,
  OR: 85,
  OM: 86,
  PS: 87,
  FA: 88,
  PL: 89,
  PT: 90,
  PA: 91,
  QU: 92,
  RO: 93,
  RU: 94,
  SM: 95,
  SA: 96,
  GD: 97,
  NSO: 98,
  SR: 99,
  ST: 100,
  SN: 101,
  SD: 102,
  SI: 103,
  SK: 104,
  SL: 105,
  SO: 106,
  ES: 107,
  SU: 108,
  SW: 109,
  SV: 110,
  TL: 111,
  TG: 112,
  TA: 113,
  TT: 114,
  TE: 115,
  TH: 116,
  TI: 117,
  TS: 118,
  TR: 119,
  TK: 120,
  AK: 121,
  UK: 122,
  UR: 123,
  UG: 124,
  UZ: 125,
  VI: 126,
  CY: 127,
  XH: 128,
  YI: 129,
  YO: 130,
  ZU: 131
};

goog.object.extend(exports, proto.com.chegg.rio.content);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-event-schema-web/dist/imports/content/language_code_pb.js
// module id = 4318
// module chunks = 11